<template>
  <ul
    v-show="totalPages > 1"
    class="flex list-reset items-center justify-center"
  >
    <li>
      <a
        class="btn btn--border btn--sm mr-2"
        href="#"
        :disabled="previousPageDisabled"
        @click.prevent="previousPage"
      >
        <svg
          width="5"
          height="9"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.5 8.3l.8-.6-2.6-3.1 2.7-3.3-.8-.6L.3 4.6z"
            fill="#000"
            fill-rule="nonzero"
          />
        </svg>
      </a>
    </li>
    <li
      v-for="(page, index) in pageRange"
      :key="`page-${index}`"
    >
      <a
        class="btn btn--sm mr-2"
        :class="[isCurrentPage(page) ? '' : 'btn--border']"
        href="#"
        @click.prevent="goToPage(page)"
        v-text="page"
      />
    </li>
    <li>
      <a
        class="btn btn--border btn--sm mr-2"
        href="#"
        :disabled="nextPageDisabled"
        :aria-disabled="nextPageDisabled"
        @click.prevent="nextPage"
      >
        <svg
          width="5"
          height="9"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 8.3l-.8-.6 2.6-3.1L.6 1.3l.8-.6 3.3 3.9z"
            fill="#000"
            fill-rule="nonzero"
          />
        </svg>
      </a>
    </li>
  </ul>
</template>

<script type="text/babel">
export default {
  name: 'Pagination',
  props: {
    pagination: {
      type: Object,
      required: true,
    },
    onChange: {
      type: [Function, Boolean],
      required: false,
      default: false,
    },
    limit: {
      type: Number,
      required: false,
      default: 2,
    },
  },
  computed: {
    totalPages() {
      return this.pagination.total_pages !== undefined ? this.pagination.total_pages : this.pagination.last_page
    },
    currentPage() {
      return this.pagination.current_page
    },
    nextPageDisabled() {
      return this.currentPage + 1 > this.totalPages
    },
    previousPageDisabled() {
      return this.currentPage - 1 < 1
    },
    pageRange() {
      if (this.limit === -1) {
        return 0
      }

      if (this.limit === 0) {
        return this.lastPage
      }

      const current = this.currentPage
      const last = this.totalPages
      const delta = this.limit
      const left = current - delta
      const right = current + delta + 1
      const range = []
      const pages = []
      let l

      for (let i = 1; i <= last; i++) {
        if (i === 1 || i === last || (i >= left && i < right)) {
          range.push(i)
        }
      }

      range.forEach((i) => {
        if (l) {
          if (i - l === 2) {
            pages.push(l + 1)
          } else if (i - l !== 1) {
            pages.push('...')
          }
        }

        pages.push(i)

        l = i
      })

      return pages
    },

  },
  methods: {
    changePage(page) {
      if (_.isFunction(this.onChange)) {
        return this.onChange(page)
      }

      const url = window.location.href

      if (url.indexOf('page=') === -1) {
        if (url.indexOf('?') === -1) {
          window.location.href = `${url}?page=${page}`
        } else {
          window.location.href = `${url}&page=${page}`
        }
      } else {
        window.location.href = url.replace(/(page=)\d+/g, `page=${page}`)
      }
    },
    previousPage() {
      if (!this.previousPageDisabled) {
        this.changePage(this.currentPage - 1)
      }
    },
    nextPage() {
      if (!this.nextPageDisabled) {
        this.changePage(this.currentPage + 1)
      }
    },
    goToPage(page) {
      if (page === '...') {
        return
      }

      if (!this.isCurrentPage(page)) {
        this.changePage(page)
      }
    },
    isCurrentPage(page) {
      return page === this.currentPage
    },
  },
}
</script>
